// @need-translate
import {getAgeGradeText} from '../../common/getAgeGradeText';
import {t} from '../../common/getTranslations';
import {AuthorVo} from '../../common/shared/api/nicolas/vo/AuthorVo.interface';
import {ContentDetailVo} from '../../common/shared/api/nicolas/vo/ContentDetailVo.interface';
import {ContentHomeDetailInfo} from '../generated/types';
import {createAgeGrade} from './AgeGrade';

export function createContentHomeDetailInfoList({
  author_list,
  detail,
}: {
  author_list: AuthorVo[];
  detail: ContentDetailVo;
}): ContentHomeDetailInfo[] {
  return [
    ...(author_list
      ? author_list.map(author => ({
          title: author.role_display_name,
          info: [author.name],
        }))
      : []),
    ...(detail.category_list && detail.category_list.length > 0
      ? [
          {
            title: t('contenthome_info_tab_category'),
            info: detail.category_list,
          },
        ]
      : []),
    ...(detail.publisher_name
      ? [
          {
            title: t('contenthome_info_tab_publisher'),
            info: [
              detail.publisher_name,
              detail.publisher_operation_label,
            ].filter(i => !!i),
          },
        ]
      : []),
    ...(detail.age_grade !== undefined
      ? [
          {
            title: t('contenthome_info_tab_age'),
            info: [getAgeGradeText(createAgeGrade(detail.age_grade), '이용가')],
          },
        ]
      : []),
    ...(detail.retail_price
      ? [
          {
            title: t('contenthome_info_tab_price'),
            info: [detail.retail_price],
          },
        ]
      : []),
  ];
}
